export default __webpack_public_path__ + "static/media/moon.872972c1.png";